import React from 'react'

import Box from '../components/Box'
import GlyphChain from '../icons/GlyphChain'

export const IsConnected = () => {
  return (
    <>
      <div className='pv4 pt4 mt4 mr4 ml4' style={{ backgroundColor: '#F8F8F8', border: "2px solid #96CCFF" }}>
        <div className='mb4'>
          <div className='flex flex-wrap items-center'>
            <GlyphChain style={{ height: 76 }} className='fill-reen' role='presentation' />
            <h1 className='san-serif fw4 charcoal ma0 font-large font-small greenmod'>You have connected to TKGGBS!</h1>
          </div>
          <div className='pl3'><strong>Welcome to our dapp.  Now, you can take benefits of Blockchain, distributed Webs, distributed storages, and distributed databases.</strong></div>
        </div>
      </div>
      <div style={{ height: '0.4em', marginRight: '2.4em', marginLeft: '2.4em', backgroundColor: '#FFFFFF' }} />
      <div className='fw6 mt1 ml3-ns w-100'></div>
    </>
  )
}

export default IsConnected;
